import { Component, OnInit } from '@angular/core';
import { filter } from 'rxjs/operators';
import { NavigationEnd } from '@angular/router';
import { Router } from '@angular/router';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: [ './app.component.scss' ]
})
export class AppComponent implements OnInit {
	title = 'acordar';
	constructor(private _router: Router) {}

	ngOnInit() {
		this._router.events
			.pipe(filter((event) => event instanceof NavigationEnd))
			.subscribe(() => window.scrollTo(0, 0));
	}
}
